import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Link } from 'foundations-components/transitional/components/Link';
import { getInboxEditUrl } from '../../../urls/inbox-urls';
import { jsx as _jsx } from "react/jsx-runtime";
const RemovedFromInboxUserTooltip = ({
  children,
  inboxId
}) => /*#__PURE__*/_jsx(Tooltip, {
  placement: "top",
  title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: {
      Link
    },
    message: "routing-ui.routingRules.users.removedFromInbox_jsx",
    options: {
      external: true,
      href: getInboxEditUrl(inboxId)
    }
  }),
  children: children
});
RemovedFromInboxUserTooltip.displayName = 'RemovedFromInboxUserTooltip';
export default RemovedFromInboxUserTooltip;